import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import TopNavFour from "../../../components/header/TopNavFour";
import InnerBanner from "../../../components/page-title/InnerBanner";
import BannerFive from "../../../components/short-banner/BannerFive";
import NewsLetterForm from "../../../components/form/NewsLetterForm";
import FooterFour from "../../../components/footer/FooterFour";
import CopyRightFour from "../../../components/footer/CopyRightFour";
// import PortfolioGalleryThree from "../../../components/portfolio/PortfolioGalleryThree";
import img1 from "../../../assets/images/shape/shape_38.svg";
import img2 from "../../../assets/images/shape/shape_39.svg";

const Portfolio3Column = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="main-page-wrapper">
      <Helmet>
        <title>Software and Platform</title>
      </Helmet>
      {/* helmet end */}
      <TopNavFour /> {/* theme-menu-four */}
      <div className="theme-inner-banner">
        <InnerBanner intro="Software & Platforms " currpage="" />
        {/* <p>
          Before you even think about rolling out your website and making your
          first hire, you’re thinking about the set of tools you’ll use to power
          your business. Tools that can handle everything from managing your
          contact database to conducting online transactions to monitoring your
          future support team’s NPS. Finding tools that can accomplish all these
          distinct needs can be challenging. Finding tools that can also play
          nice together can be downright overwhelming. With a platform as the
          foundation of your business ecosystem, you don’t have to limit
          yourself to one suite of products — you can add and subtract new
          applications and tools as your business grows and changes, without
          having to start from scratch again or deal with messy migrations. As
          Scott Brinker, VP, Platform Ecosystem at HubSpot explains, it can be
          helpful to imagine a platform as a central place where different
          products connect: “Almost every SaaS product today has APIs that let
          it exchange data with other applications. A platform, however, plays a
          more active role in coordinating how multiple products work together.
          You can picture a platform as a hub, with spokes connecting other
          products to its center. The hub binds those disparate products
          together and orchestrates them in a common mission. A platform creates
          a stable center of gravity for your tech stack “ In simple terms, a
          software product is a set of tools from one company that comes in one
          package. Everything contained within that package is designed to work
          together, but it can be challenging to add on new tools that didn’t
          originally come in the package. For example, if you wanted to add a
          new help desk tool that works directly with your existing CRM, you’d
          need to build an integration that can connect the new tool to your
          existing product suite. The help desk tool wasn’t originally designed
          to work with your product suite, but an integration can effectively
          enable them to pass information back and forth.
        </p> */}
        <img src={img1} alt="" className="shapes shape-one" />
        <img src={img2} alt="" className="shapes shape-two" />
      </div>
      {/* /.theme-inner-banner */}
      <div className="portfolio-gallery-three mt-140 mb-150 lg-mt-90 lg-mb-100">
        {/* <div className="container">
          <PortfolioGalleryThree />
        </div> */}
      </div>
      {/* /.portfolio-gallery-three */}
      <div className="fancy-short-banner-five">
        <div className="container">
          <div className="bg-wrapper">
            <BannerFive />
          </div>
          {/* /.bg-wrapper */}
        </div>
        {/* /.container */}
      </div>
      {/* /.fancy-short-banner-five */}
      <div className="footer-style-four space-fix-one theme-basic-footer">
        <div className="container">
          <div className="inner-wrapper">
            <div className="subscribe-area">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="title-style-four sm-pb-20">
                    <h4 className="main-title">
                      Join Our <span>Newsletter</span> &amp; Get updated.
                    </h4>
                  </div>
                  {/* /.title-style-four */}
                </div>
                <div className="col-md-6">
                  <div className="subscribe-form">
                    <NewsLetterForm />
                    <p>We only send interesting and relevant emails.</p>
                  </div>
                  {/* /.subscribe-form */}
                </div>
              </div>
            </div>
            {/* /.subscribe-area */}
            <FooterFour />
            <div className="bottom-footer">
              <CopyRightFour />
            </div>
          </div>
          {/* /.inner-wrapper */}
        </div>
      </div>
      {/* /.footer-style-four */}
    </div>
  );
};

export default Portfolio3Column;
